import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

const {
  grid: { resolution, spacing },
  borderRadius,
  primaryColours,
} = theme

export const ExplainerStyles = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${primaryColours.white.main};
  border-radius: ${borderRadius.double};

  .section {
    display: flex;
    flex: 1;
    justify-content: flex-start;
  }

  .step-wrapper {
    padding: ${spacing.s}px;
  }

  @media (max-width: ${resolution.tablet.width}px) {
    .button {
      width: 100%;
    }
  }

  @media (min-width: ${resolution.tablet.width}px) {
    flex-direction: row;

    .section {
      justify-content: center;
    }
  }
`
